import {useMemo} from 'react';

import {
  AppConfig,
  AppProfile,
  SupportTriggerPointTriggerPoint,
} from '@stripe-internal/conversations-assistant';
import {Observability} from '@stripe-internal/conversations-client';

import {MobileAssistantContainer} from './components/MobileAssistantContainer';
import {MobileAssistantProviders} from './providers/MobileAssistantProviders';
import {MobileAssistantScreen} from './components/MobileAssistantScreen';

type Props = {
  config: AppConfig;
  profile: AppProfile;
  observability?: Observability;
};

export function MobileAssistant({config, profile, observability}: Props) {
  const configWithTriggerPoint = useMemo(() => {
    let triggerPoint: SupportTriggerPointTriggerPoint = 'unspecified';
    if (config.entryPoint === 'mobile_ios') {
      triggerPoint = 'dashboard_mobile_ios_app_get_help';
    } else if (
      ['react_native_mobile_ios', 'react_native_mobile_android'].includes(
        config.entryPoint,
      )
    ) {
      triggerPoint = 'react_native_mobile_get_help';
    } else if (
      ['mobile_link_ios', 'mobile_link_android'].includes(config.entryPoint)
    ) {
      triggerPoint = 'link_mobile_get_support';
    }

    return {
      ...config,
      triggerPoint,
    };
  }, [config]);

  return (
    <MobileAssistantProviders
      config={configWithTriggerPoint}
      profile={profile}
      observability={observability}
    >
      <MobileAssistantContainer>
        <MobileAssistantScreen />
      </MobileAssistantContainer>
    </MobileAssistantProviders>
  );
}
